<button
    type="button"
    class="training-banner"
    (click)="onClick()"
>
    <span>You are currently in training mode. <span class="training-banner-cta">Click to complete.</span></span>
</button>

<p-dialog
    header="Complete Training"
    [modal]="true"
    [visible]="confirmVisible()"
    (visibleChange)="confirmVisible.set($event)"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '30rem', 'max-width': '95vw' }"
>
    <p class="mb-2">Submit your training as complete?</p>
    <p class="mb-0">An administrator will review and approve your account.</p>

    <ng-template #footer>
        <p-button
            label="Cancel"
            severity="secondary"
            (onClick)="confirmVisible.set(false)"
            [disabled]="isSubmitting()"
        />
        <p-button
            label="Submit"
            icon="pi pi-check"
            (onClick)="submit()"
            [loading]="isSubmitting()"
        />
    </ng-template>
</p-dialog>
